import React from 'react';

const CourseDetails = ({ course, onClose }) => {
  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <div className="rounded-circle bg-warning d-flex align-items-center justify-content-center me-3" style={{ width: "48px", height: "48px" }}>
              <span className="text-white fw-semibold">LP</span>
            </div>
            <h2 className="fs-5 fw-semibold mb-0">Course Added</h2>
          </div>
          <button className="btn btn-sm btn-light" onClick={onClose}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        
        <div className="mb-4">
          <div className="mb-3">
            <h3 className="fs-5 fw-medium mb-2">{course.title}</h3>
            <p className="text-secondary">{course.description}</p>
          </div>
          
          <div className="mb-3">
            <h4 className="fs-6 fw-medium text-secondary mb-1">Category</h4>
            <p>{course.category}</p>
          </div>
          
          <div className="mb-3">
            <h4 className="fs-6 fw-medium text-secondary mb-1">Begin Date</h4>
            <p>{new Date(course.beginDate).toLocaleDateString()}</p>
          </div>
          
          {course.curriculum && course.curriculum.length > 0 && (
            <div className="mb-3">
              <h4 className="fs-6 fw-medium text-secondary mb-1">Curriculum</h4>
              <ul className="list-disc ps-4">
                {course.curriculum.map((item, index) => (
                  <li key={index}>{item.title}</li>
                ))}
              </ul>
            </div>
          )}
          
          {course.materials && course.materials.length > 0 && (
            <div className="mb-3">
              <h4 className="fs-6 fw-medium text-secondary mb-1">Materials</h4>
              <ul className="list-disc ps-4">
                {course.materials.map((item, index) => (
                  <li key={index}>{item.title}</li>
                ))}
              </ul>
            </div>
          )}
          
          {course.quizzes && course.quizzes.some(quiz => quiz.selected) && (
            <div className="mb-3">
              <h4 className="fs-6 fw-medium text-secondary mb-1">Quizzes</h4>
              <ul className="list-disc ps-4">
                {course.quizzes
                  .filter(quiz => quiz.selected)
                  .map((quiz, index) => (
                    <li key={index}>{quiz.title}</li>
                  ))}
              </ul>
            </div>
          )}
          
          {course.thumbnail && (
            <div className="mb-3">
              <h4 className="fs-6 fw-medium text-secondary mb-1">Thumbnail</h4>
              <p>{course.thumbnail}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;